<template>
    <div style="margin-top: 10px">
        <label> {{ label }} </label>
        <div v-if="!modal" class="img-wrapper">
            <img :src="image ? image : defaultImage">
            <div class="close" v-if="exist" @click="close" >╳</div>
        </div>
        <div v-else>
            <el-dialog
                title="Image"
                :visible.sync="centerDialogVisible"
                center>
                    <img :src="image">
                    
                    <InputField label="Name"
                        typeField="text"
                        inputNote="*Name must be unique"
                        v-model="name"/>
                    
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="centerDialogVisible = false">Cancel</el-button>
                        <el-button type="primary" @click="confirmImage()">Confirm</el-button>
                    </span>
            </el-dialog>
            
        </div>
        <div v-if="!disableUpload" style="text-align: center"> 
            <label for="logo"  class="custom-file-upload"> <i class="el-icon-upload"/>
                Upload file
                <input id="logo" type="file" @input="onFileChange" @change="onFileChange" style="display: none"/>
            </label>
        </div>
    </div>
</template>

<script>
    import {ImageUrl} from '@/main'
    import api from '@/api/api'
    import {mapGetters} from 'vuex'
    import InputField from '../Inputs/InputField'
    import noImage from '@/assets/no_image.png'
    
    export default {
        components: {
            InputField
        },
        props: {
            id: {
                type: Number
            },
            disableUpload: {
                type: Boolean
            },
            label: {
                type: String,
                default: 'Logo'
            },
            // name: {
            //     type: String,
            // },
            originalImage: {},
            modal: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters({
                authToken: 'getAuthToken'
            }),
            timestamp() {
                return Date.now();
            }
        },
        data() {
            return {
                image: '',
                name: '',
                exist: false,
                centerDialogVisible: false,
                form: FormData,
                defaultImage: noImage
            }
        },
        created () {
            this.originalImage ? this.image = `${ImageUrl}${this.originalImage}?time=${this.timestamp}` : this.image = ''
        },
        watch: {
            name () {
                console.log(this.name);
                
            },
            originalImage () {
                this.originalImage ? this.image = `${ImageUrl}${this.originalImage}?time=${this.timestamp}` : this.image = ''
            }
        },
        methods: {
            onFileChange(e) {
                console.log(e)
                const files = e.target.files || e.dataTransfer.files;
                const formData = new FormData();
                    
                // this.name = files[0].name
                formData.append('name', files[0].name);
                formData.append('image', files[0]);
                
                this.form = files

                

                if(!files.length) {
                    return;
                }
                
                if (this.modal) {
                    this.centerDialogVisible = true
                } else {
                    this.$emit('formData', formData);
                }

                this.imagePreview(files[0]);
                
                
                this.image = '';
                this.name = '';
            },
            imagePreview(file) {
                const reader = new FileReader();
                
                reader.onload = e => {
                    this.image = e.target.result;
                    this.exist = true;
                };
                
                reader.readAsDataURL(file);
            },
            close() {
                this.image = '';
                this.exist = false;
            },
            confirmImage () {
                let files = this.form
                
                const formData = new FormData();
                formData.append('name', this.name);
                formData.append('image', files[0]);
                
                this.centerDialogVisible = false
                this.$emit('formData', formData)
            }
        }
    }
</script>

<style scoped>
    /* i {
        margin-right: 8px;
    } */
    .custom-file-upload {
        border: 1px solid white;
        display: inline-block;
        margin: 10px;
        padding: 6px 12px;
        cursor: pointer;
        color: #409EFF;
        font-size: 18px;
    }
    .custom-file-upload:hover, :focus {
        color: rgb(96, 173, 250);
    }
    .modal-image-preview {
        width: 50%; 
        height: 50%; 
        max-width: 500px; 
        max-height: 500px; 
        padding: 10px
    }

    img {
        height: 50%;
        width: 50%;
        object-fit: contain;    
    }
    .el-dialog--center .el-dialog__body {
        text-align: center !important;
    }
    .h3 {
        font-size: 14px;
        font-weight: 100 !important;
        text-align: left !important;
    }
    .el-dialog {
        max-width:500px !important;
    }
    .el-input__inner {
        color: transparent;
        margin: 10px 0;
    }
    .img-wrapper {
        position: relative;
    }
    .img-wrapper img {
        width: 50%;
        display: block;
        margin: 0 auto;
    }
    .img-wrapper .close {
        position: absolute;
        top: 0;
        right: 0;
        opacity: 1;
        font-size: 13px;
        padding: 0 0.4em 1.5em 1.5em;
        cursor: pointer;
        z-index: 1;
        
        /*transition: opacity 0.2s ease 0.1s, color 0.2s, -webkit-transform 0.2s;*/
        /*transition: opacity 0.2s ease 0.1s, color 0.2s, transform 0.2s;*/
        /*transition: opacity 0.2s ease 0.1s, color 0.2s, transform 0.2s, -webkit-transform 0.2s;*/
    }
</style>



// WEBPACK FOOTER //
// src/components/UploadFile/UploadFile.vue